export const userTypeMap = {
  0: 'USER',
  1: 'AGENT',
  2: 'AGENT',
  3: 'CARRIER'
}
